export const CONTACTENOS_ACTIVACION = 'Contactenos para activar su cuenta';
export const ERROR_ENVIO_EMAIL = 'Error al enviar el email, intenta mas tarde.';

